import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans";
import "@fontsource/dm-sans/700.css";

import { initConsentFromCookie } from "./src/analytics";

// Google Analytics 4 — send a page_view on client-side route changes. The first
// route update fires right after the SSR-injected gtag('config') already logged
// the initial page_view, so we skip it to avoid double-counting. GA respects
// Consent Mode automatically (cookieless until the banner is accepted).
const GA_MEASUREMENT_ID = process.env.GATSBY_GA_ID || "G-B406PMCBR0";
let gaFirstRoute = true;

// Returning visitors who accepted in a prior session: re-grant consent so
// analytics/ads resume without re-prompting.
export const onClientEntry = () => {
  initConsentFromCookie();
};

export const onRouteUpdate = ({ location }) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;
  if (gaFirstRoute) {
    gaFirstRoute = false;
    return;
  }
  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: location.pathname + location.search + location.hash,
  });
};
